// Datos para informes estratégicos de análisis electoral.
//
// Vaciado tras auditoría: los informes previos ("genérico" y "San Nicolás")
// contenían nombres y datos ficticios/hardcodeados presentados como reales.
// Se deja el export vacío para que StrategicAnalysisReport muestre su estado
// vacío (no renderiza nada) hasta que se cargue un informe real generado con
// IA sobre datos verificados.

const strategicReports = {};

export default strategicReports;
